<div class="card">
    <div class="card-body">
        <h5 class="card-title">{{ 'users.cardTitle' | t }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'selectExportTypeBelow' | t }}</h6>

        <hr />

        <button class="btn btn-default me-2 mb-2" (click)="download(ExportType.UsersImport)">
            {{ 'users.exportForImportButton' | t }}
        </button>
    </div>
</div>
